const SearchIcon = ({ color = false, className = '' }) => {
  const fillColor = color ? color : "currentColor";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
      <g clipPath="url(#clip0_4_39)">
        <path d="M23.962 23.255L16.558 15.851C18.075 14.167 19 11.939 19 9.5C19 4.262 14.738 0 9.5 0C4.262 0 0 4.262 0 9.5C0 14.738 4.262 19 9.5 19C11.94 19 14.167 18.075 15.851 16.558L23.255 23.962L23.962 23.255ZM9.5 18C4.813 18 1 14.187 1 9.5C1 4.813 4.813 1 9.5 1C14.187 1 18 4.813 18 9.5C18 14.187 14.187 18 9.5 18Z" fill={fillColor}/>
      </g>
      <defs>
        <clipPath id="clip0_4_39">
          <rect width="24" height="24" fill={fillColor} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchIcon;
